import React from 'react'

import { ProfileComponent } from '../components/profile/'




export const Profile = () => {

    return <ProfileComponent />
}